import LoadingSpinner from '@/shared/components/LoadingSpinner/LoadingSpinner';
import SettingsViewWrapper from '@/shared/components/SettingsViewWrapper/SettingsViewWrapper';
import { useUser } from '@/shared/hooks/user';
import { Trans, useTranslation, withTranslation } from 'react-i18next';
import { IonButton, IonRouterLink, IonText } from '@ionic/react';
import contactInformation from '@/shared/config/contactInformation';
import styles from './AddressChange.module.css';

const AddressChange: React.FC = () => {
  const { t } = useTranslation();

  const user = useUser();

  return (
    <SettingsViewWrapper name="address-change-page" title={t('address_change.title')}>
      {user ? (
        <div className={styles.container}>
          <IonText>{t('address_change.description')}</IonText>
          <div className={styles.addressChangeContainer}>
            <IonText>{t('address_change.text_field.label')}</IonText>
            <div className={styles.buttonWrapper}>
              <IonButton
                size="small"
                href={'/documents/Annex_2-4_Whitelisting.pdf'}
                download={'Annex_2-4_Whitelisting.pdf'}
              >
                {t('address_change.text_field.download')}
              </IonButton>
            </div>
          </div>
          <IonText>
            <Trans
              i18nKey="address_change.contact_info"
              values={{ emailAddress: contactInformation.sales.title }}
              components={{ email: <IonRouterLink href={contactInformation.sales.url} target="_blank" /> }}
            />
          </IonText>
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </SettingsViewWrapper>
  );
};

export default withTranslation()(AddressChange);
